<script>
import {Button} from 'vant';
import {loadScript} from '@/libs/util';

export default {
  name: 'PayResult',
  components: {
    [Button.name]: Button
  },
  props: {
    typeParam: {
      type: Number,
      required: true
    },
    snParam: {
      type: String,
      required: true
    },
    moneyParam: {
      type: Number,
      required: true
    },
    gunCodeParam: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    loadScript(['https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js']).then(() => {
      let mchData = {action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE'};
      parent.postMessage(JSON.stringify({action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE'}), 'https://payapp.weixin.qq.com')
    });
  },
  computed: {},
  methods: {}
}
</script>

<template>
  <div id="payResult">
    {{ typeParam }},{{ snParam }},{{ moneyParam }},{{ gunCodeParam }}

    <van-button v-if="typeParam == 2" round size="small">确定</van-button>
  </div>
</template>

<style scoped>
#payResult {
  width: 640px;
  height: 600px;
}
</style>
